import { Injectable } from '@angular/core';
import Keycloak from 'keycloak-js';

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  private roles: Array<string> = [];

  constructor(private keycloak: Keycloak) {
    this.initializeRoles();
  }

  private initializeRoles(): void {
    if (this.keycloak.authenticated) {
      console.log('User is authenticated, initializing roles');
      const role = this.keycloak.tokenParsed?.resource_access?.['formation']?.roles ?? [];
      console.log('Roles from token:', role);
      this.roles.push(...role);
    }
  }

  hasRole(role: string): boolean {
    console.log('Checking role:', role);
    if (role.includes(',')) {
      let roles = role.split(',');
      for (let r of roles) {
        if (this.roles.indexOf(r) >= 0) {
          return true;
        }
      }
      return false;
    }
    return this.roles.indexOf(role) >= 0;
  }
  hasNoRole(): boolean {
    return this.roles.length === 0;
  }
}